import React from "react";

import { useProductsContext } from "../state/products";
import { TotalResults } from "./BaseTotalResults";

export const ProductsTotalResults: React.FC = () => {
  const { totalResults, loading } = useProductsContext();
  return <TotalResults total={totalResults} loading={loading} />;
};
